import { render, staticRenderFns } from "./my-education-material.vue?vue&type=template&id=366558d4&scoped=true&"
import script from "./my-education-material.vue?vue&type=script&lang=js&"
export * from "./my-education-material.vue?vue&type=script&lang=js&"
import style0 from "./my-education-material.vue?vue&type=style&index=0&id=366558d4&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "366558d4",
  null
  
)

export default component.exports